export const featuresFlag = {
  "prospective-tenants": false,
  "bookings": true,
  "sorting": true,
  "favourite": true,
  "corporate-accounts": true,
  "mondu": false,
  "subscription": true,
  "flights": true,
}
